export const imageEditFormFields = {
  title: 'title',
  description: 'description',
};

export const errorMessages = {
  required: 'This field is required',
};
